import axios from 'axios';
import { serverHost } from '../../../redux/reducers/reducer';

export default  async function resetSite(site_name){
    const server =serverHost();
    try {
      const response = await   axios.post(server +'/site/restartSite',{site: site_name});
      if (response.status === 200){
        const dataArr = response.data; //[{site_name:',id:uuid}]
        return dataArr.message;
      }else{
        console.error('Error:', response.statusText);
        return response.data.error;
      }
    }catch(err){
        console.error(err.message)
        return null;
    }
}